import React from 'react';
import './ResetPwd.scss';

const Card = ({
  handleStateChange,
  handlerReset,
  validator,
  state,
  loading
}) => {
  return (
    <form className="nf-login-form" onSubmit={(e) => handlerReset(e)}>
      <div className="nf-group-input">
        <input type="password" className="nf-input" placeholder="New password" onChange={(e) => handleStateChange('pd', e.target.value)} />
        {validator.message('Password', state.pd, 'required|required')}
      </div>
      <div className="nf-group-input">
        <input type="password" className="nf-input" placeholder="Confirm password" onChange={(e) => handleStateChange('npd', e.target.value)} />
        {validator.message('Re-Type password', state.npd, 'required|required')}
      </div>
      <div className="nf-btn-login mt-10">
        {
          loading == false ?
            <button className="nf-btn  nf-btn-primary" type='submit'> Reset my password </button>
            :
            <div className="nf-btn  nf-btn-primary"> <div className="loading-circle"></div> </div>
        }
      </div>
    </form>
  );
};

export default Card;


// WEBPACK FOOTER //
// ./src/components/ResetPwd/ResetPwd.js